import React, { Component } from "react";
import TextField from  "@material-ui/core/TextField";
import { string, shape, func, bool } from 'prop-types';
import { isEqual } from 'lodash';
import moment from 'moment';

import styles from './styles.scss';
import { dateToString } from '../../../helpers/formatData';
import { validateDateFieldCalendar, validateDateRange, checkMaximumDuration } from '../../../helpers/validate';
import { EVENT_TYPE } from '../Calendar/withRange';

const initialState = {
  start: "",
  end: "",
  startError: false,
  endError: false,
  errorMessage: ""
}
export default class RangeInput extends Component {
  static propTypes = {
    selected: shape({
      start: string,
      end: string
    }),
    onChangeStartBound: func,
    onChangeEndBound: func,
    onError: func,
    error: {
      errorMessage: string,
      isStartError: bool,
      isEndError: bool,
    },
    format: string,
    rangeLimitErrorMessage: string,
    dateInvalidErrorMessage: string,
    rangeErrorMessage: string
  }

  static defaultProps = {
    error: {},
    format: 'MM/DD/YYYY',
    rangeLimitErrorMessage: 'Date range cannot exceed ${number} days.',
    dateInvalidErrorMessage: 'Date is invalid.',
    rangeErrorMessage: 'Start date cannot be greater than end date.'
  }

  state = {
    ...initialState,
    prevError: {}
  }

  
  componentDidMount = () => {
    const { selected } = this.props;
    const { start, end } = selected;
    const error = this.checkRangeErrors(selected);
    const { isStartError, isEndError, errorMessage } = error || {};
    this.setState({
      start: dateToString(start),
      end: dateToString(end),
      isStartError,
      isEndError,
      errorMessage
    });
  }

  componentDidUpdate = (prevProps) => {
    const { start: startState, end: endState } = this.state;
    const { selected: prevSelected } = prevProps;
    const { selected, onError } = this.props;
    const { start, end } = selected;
    
    if (!isEqual(selected, prevSelected)) {
      // compare to prevent changing the pointer poisition in date field
      const newStart = moment(startState, ['MM/DD/YYYY', 'M/D/YYYY']).isSame(moment(start, 'YYYY-MM-DD')) ? startState : dateToString(start);
      const newEnd = moment(endState, ['MM/DD/YYYY', 'M/D/YYYY']).isSame(moment(end, 'YYYY-MM-DD')) ? endState : dateToString(end);
      const error = this.checkRangeErrors(selected);
      const { isStartError, isEndError, errorMessage } = error || {};
      this.setState({
        start: newStart,
        end: newEnd,
        isStartError,
        isEndError,
        errorMessage
      });
      onError && onError(!!error);
    }
  }

  checkRangeErrors = (selected = {}) => {
    const { start, end } = selected;
    if (!start || !end) {
        return;
    }
    let error;
    const { dateRangeLimitInDays, rangeLimitErrorMessage } = this.props;
    if (
        dateRangeLimitInDays
        && !checkMaximumDuration(start, end, dateRangeLimitInDays)
    ){
        const errMessage = rangeLimitErrorMessage.replace('${number}', dateRangeLimitInDays);
        error = {
            isStartError: !!errMessage,
            errorMessage: errMessage
        }
    }
    return error;
}

  handleChangeStart = (event) => {
    const { value: date } = event.target;
    const {
      onChangeStartBound,
      onChangeEndBound,
      onError,
      format,
      dateInvalidErrorMessage,
      rangeErrorMessage
    } = this.props;
    const { end } = this.state;
    let error;
    
    if (!validateDateFieldCalendar(date)) {
      error = {
        isStartError: true,
        errorMessage: dateInvalidErrorMessage
      }
    } else if (!validateDateFieldCalendar(end)) {
      error = {
        isEndError: true,
        errorMessage: dateInvalidErrorMessage
      }
    } else if (!validateDateRange(date, end, format)) {
      error = {
        isStartError: true,
        errorMessage: rangeErrorMessage
      }
    } else {
      error = this.checkRangeErrors({ start: date, end });
      onChangeStartBound && onChangeStartBound(new Date(date));
      onChangeEndBound && onChangeEndBound(new Date(end));
    }

    const { isStartError, isEndError, errorMessage } = error || {};
    this.setState({
      start: date,
      isStartError,
      isEndError,
      errorMessage
    });
    onError && onError(!!error);
  }

  handleChangeEnd = (event) => {
    const { value: date } = event.target;
    const {
      onChangeStartBound,
      onChangeEndBound,
      onError,
      format,
      rangeErrorMessage,
      dateInvalidErrorMessage
    } = this.props;
    const { start } = this.state;
    let error;

    if (!validateDateFieldCalendar(date)) {
      error = {
        isEndError: true,
        errorMessage: dateInvalidErrorMessage
      }
    } else if (!validateDateFieldCalendar(start)){ 
      error = {
        isStartError: true,
        errorMessage: dateInvalidErrorMessage
      }
    } else if (!validateDateRange(start, date, format)) {
      error = {
        isEndError: true,
        errorMessage: rangeErrorMessage
      }
    } else {
      error = this.checkRangeErrors({ start, end: date });
      onChangeEndBound && onChangeEndBound(new Date(date));
      onChangeStartBound && onChangeStartBound(new Date(start));
    }
    const { isStartError, isEndError, errorMessage } = error || {};
    this.setState({
      end: date,
      isStartError,
      isEndError,
      errorMessage
    });
    onError && onError(!!error);
  }

  render() {
    const {
      start,
      end,
      isStartError,
      isEndError,
      errorMessage
    } = this.state;
    const errorElement = <span className={styles.errorTextField}>
                          {errorMessage}
                        </span>

    return (
      <div className={styles["container"]}>
        <div className={styles["inputContainer"]}>
          <TextField
            data-test="formStartDateInput"
            label="Custom"
            value={start}
            onChange={this.handleChangeStart}
            error={isStartError}
          />
          <span className={styles["separate"]}> to </span>
          <TextField
            data-test="formToDateInput"
            label="Custom"
            value={end}
            onChange={this.handleChangeEnd}
            error={isEndError}
          />
        </div>
        <div>{errorMessage && errorElement}</div>
      </div>
    )
  }
}
